<template>
  <div>
    <a-form class="custom-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="8" :xxl="6">
          <a-form-item label="提醒名称">
            <a-input
              v-decorator="['name', {
                normalize: this.$lodash.trim
              }]"
              placeholder="提醒名称"
              autocomplete="off"
              allow-clear
            >
              <a-icon slot="prefix" type="search" />
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8" :xxl="6">
          <a-form-item label="状态">
            <a-select
              v-decorator="['effective']"
              placeholder="请选择状态"
              allow-clear
            >
              <a-select-option key="true" value="true">
                生效
              </a-select-option>
              <a-select-option key="false" value="false">
                失效
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="8" :xxl="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>
<script>
export default {
  name: 'SearchDeathDayRemind',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'death_day_remind' })
    }
  },
  methods: {
    handleSearch(e) {
      e.preventDefault()
      this.$emit('submit', this.form.getFieldsValue())
    },

    handleReset() {
      this.form.resetFields()
      this.$emit('submit', {})
    }
  }
}
</script>

